import { render, staticRenderFns } from "./myDailyList.vue?vue&type=template&id=36135d5d&scoped=true"
import script from "./myDailyList.vue?vue&type=script&lang=js"
export * from "./myDailyList.vue?vue&type=script&lang=js"
import style0 from "./myDailyList.vue?vue&type=style&index=0&id=36135d5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36135d5d",
  null
  
)

export default component.exports